module.exports = __webpack_public_path__ + "bg-register-point.png?9f9edc762aa77caa3bde9ab4e3af6938";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-register-point.png
// module id = 1101
// module chunks = 0